import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../store/auth/auth.action';
import { routes } from '../utils/constants/routes';
import { Loader } from './Routes.style';

const LogOut = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const redirectUrl = decodeURIComponent(
      window.sessionStorage.getItem('oktaLogOutRedirect') ?? ''
    );
    window.sessionStorage.removeItem('oktaLogOutRedirect');
    dispatch(
      logout({
        redirect: redirectUrl !== '' ? redirectUrl : routes.login,
        logoutType: 'user'
      })
    );
  }, [dispatch]);

  return <Loader dataTestId="loader-logout-screen" />;
};

export default LogOut;
